import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faListCheck,
  faCheck,
  faClock,
  faCircleDashed,
} from '@fortawesome/pro-regular-svg-icons'
import Typography from '@mui/material/Typography'
import { FundingProgress } from '../../api/fundingApi'
import { formatStageTime } from '../../utils/format'
import { SectionCard } from './SectionCard'
import { useStyles } from './FundRequestProgress.styles'

interface FundRequestProgressProps {
  progress: FundingProgress | null | undefined
}

const stateIcon = {
  completed: faCheck,
  current: faClock,
  upcoming: faCircleDashed,
} as const

export const FundRequestProgress = ({ progress }: FundRequestProgressProps) => {
  const { classes, cx } = useStyles()
  const stages = progress?.stages ?? []

  return (
    <SectionCard
      icon={faListCheck}
      title="Funding request progress"
      collapsible
      testId="funding-detail-progress"
    >
      {stages.length === 0 ? (
        <Typography component="p" className={classes.empty}>
          No progress available yet.
        </Typography>
      ) : (
        <ol className={classes.stepper}>
          {stages.map((stage, index) => {
            const time = formatStageTime(stage.entered_at)
            const isLast = index === stages.length - 1
            const lineComplete = stage.state === 'completed'
            return (
              <li className={classes.step} key={`${stage.stage}-${index}`}>
                <div className={classes.rail}>
                  <span className={cx(classes.node, classes[stage.state])}>
                    <FontAwesomeIcon icon={stateIcon[stage.state]} />
                  </span>
                  {!isLast && (
                    <span
                      className={cx(
                        classes.line,
                        lineComplete && classes.lineComplete
                      )}
                    />
                  )}
                </div>
                <div className={classes.content}>
                  <Typography component="span" className={classes.stageName}>
                    {stage.stage}
                  </Typography>
                  {time && (
                    <Typography component="span" className={classes.stageTime}>
                      {time}
                    </Typography>
                  )}
                </div>
              </li>
            )
          })}
        </ol>
      )}
    </SectionCard>
  )
}
